export interface RealSaleBannerProps {
  variant: 'serps' | 'product';
  saving?: number;
}

const RealSaleBanner = ({ saving, variant }: RealSaleBannerProps) => {
  const BannerCopy = ({ saving, variant }: RealSaleBannerProps) => {
    if (variant === 'serps')
      return <>Don&apos;t miss the UK&apos;s biggest used car sale!</>;

    if (variant === 'product' && saving)
      return (
        <>
          Save <span className="ch-color--ac-yellow">£{saving}</span> on this
          car today!
        </>
      );

    return <>Over 20,000 used cars on sale!</>;
  };

  return (
    <div className="ac-promo ac-promo--realsale">
      <div className="ac-promo__heading">
        <p className="ac-promo__title ch-mb--0 ch-fs--4 md:ch-fs--5 ch-fw--600">
          <BannerCopy saving={saving} variant={variant} />
        </p>
      </div>
    </div>
  );
};

export default RealSaleBanner;
